import { RadioGroup } from "radix-ui";
import { cn } from "../lib/cn";

export interface RadioSegmentOption {
	value: string;
	label: string;
	/** Ширина сегмента. «Rather not say» шире соседей — в макете flex 1.2. */
	flex?: number;
	disabled?: boolean;
}

export interface RadioSegmentProps {
	options: readonly RadioSegmentOption[];
	value?: string;
	defaultValue?: string;
	onValueChange?: (value: string) => void;
	name?: string;
	/** Обязательна: группа без подписи не читается скринридером как выбор. */
	label: string;
	disabled?: boolean;
	className?: string;
}

/**
 * Сегментный переключатель на серой подложке r12 (пол в онбординге).
 *
 * Выбранный сегмент белеет и получает мягкую тень — ровно как активная
 * вкладка `Tabs`. Зелёной обводки здесь больше нет (решение владельца
 * 22.08.2026): два похожих переключателя в одной витрине выглядели как разные
 * элементы, а зелёный контур ещё и спорил с брендовой заливкой соседних
 * кнопок. Стиль выделения теперь один на оба компонента.
 *
 * Для двух-трёх коротких взаимоисключающих значений. Длинные списки — Select.
 */
export function RadioSegment({
	options,
	value,
	defaultValue,
	onValueChange,
	name,
	label,
	disabled,
	className,
}: RadioSegmentProps) {
	return (
		<RadioGroup.Root
			value={value}
			defaultValue={defaultValue}
			onValueChange={onValueChange}
			name={name}
			aria-label={label}
			disabled={disabled}
			orientation="horizontal"
			className={cn("flex gap-1.5 rounded-card bg-sunken p-1", className)}
		>
			{options.map((option) => (
				<RadioGroup.Item
					key={option.value}
					value={option.value}
					disabled={option.disabled}
					style={{ flex: option.flex ?? 1 }}
					className={cn(
						"iec-press inline-flex min-h-12 min-w-0 items-center justify-center rounded-control px-2 t-meta",
						"break-words text-center text-fg-secondary",
						"hover:text-fg",
						"data-[state=checked]:bg-card data-[state=checked]:text-fg",
						"data-[state=checked]:shadow-pill",
						"focus-ring",
						"disabled:cursor-not-allowed disabled:opacity-60",
					)}
				>
					{option.label}
				</RadioGroup.Item>
			))}
		</RadioGroup.Root>
	);
}
